import { connect } from 'react-redux';
import { getShops } from '../shops/selectors';

const mapStateToProps = state => ({
  shops: getShops(state),
});

export default connect(mapStateToProps);



// WEBPACK FOOTER //
// ./src/app/hoc/WithShops.js